import { animateChild, query, transition, trigger } from '@angular/animations';
import { CdkAccordionItem } from '@angular/cdk/accordion';

import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  OnDestroy,
  OnInit,
  computed,
  inject,
  input,
} from '@angular/core';
import { rotateWithState, slideUpDownWithState } from 'common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { SS_ACCORDION_STYLING } from '../accordion-style';

@Directive({
  selector: '[ssAccordionItemTitle]',
  standalone: true,
})
export class AccordionItemTitleDirective {}

@Directive({
  selector: '[ssAccordionItemDivider]',
  standalone: true,
})
export class AccordionItemDividerDirective {}

@Component({
  selector: 'ss-accordion-item',
  imports: [],
  animations: [
    trigger('expandAnimations', [
      transition('* <=> *', [query('@*', animateChild())]),
    ]),
    rotateWithState,
    slideUpDownWithState(),
  ],
  host: {
    '[attr.id]': 'hostId()',
  },
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionItemComponent
  extends CdkAccordionItem
  implements OnInit, OnDestroy
{
  styling = inject(SS_ACCORDION_STYLING);
  customId = input<string | undefined>();
  hostId = computed(() => this.customId() ?? this.id);
  routeFragment = inject(ActivatedRoute).snapshot.fragment;
  router = inject(Router);
  private readonly destroy$ = new Subject<void>();

  override ngOnInit(): void {
    const customId = this.customId();
    if (customId && this.routeFragment?.includes(customId)) {
      this.open();
    }

    this.opened.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (customId) {
        this.router.navigate([], {
          fragment: customId,
          queryParamsHandling: 'merge',
          state: { ignoreScroll: true },
        });
      }
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
